import { primitive } from '@rbilabs/components-library/build/designTokens/primitives';
import styled from 'styled-components';

import { Modal } from 'components/modal';
import {
  OfferRewardContainer,
  RewardsTitle,
} from 'pages/loyalty/loyalty-offers-rewards/loyalty-offers-rewards.styled';

// import { primitive } from 'styles/constants/primitives';

export const LoyaltyOffersGridContainer = styled(OfferRewardContainer)`
  padding-block: 0;
  padding-block-end: 5rem;
  gap: 0rem;
  flex-grow: 1;
  ${Styles.desktop} {
    padding-block-end: 2rem;
  }
`;

export const OfferTitle = styled(RewardsTitle)`
  padding-block-start: 0.5rem;

  ${Styles.desktop} {
    padding-block-end: 0;
  }
`;

export const StyledV2Modal = styled(Modal)`
  &.offer-detail-v2-modal {
    background-color: ${primitive.$white};
  }
`;

export const StyledExternalModal = styled(Modal)`
  &.external-offer-detail-v2-modal {
    background-color: ${primitive.$white};
  }
`;

export const PromoCodeCTA = styled.button`
  font-family: ${Styles.fontFamily.body};
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
  letter-spacing: normal;
  text-decoration: underline;
  background: none;
  border: 0;
  cursor: pointer;
  padding: 0;

  ${Styles.desktop} {
    font-size: 1.125rem;
    line-height: 1.25rem;
  }
`;

export const OfferTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-block-end: 1rem;
`;

export const OfferStickyContainer = styled.div`
  padding-block: 0.5rem;
  position: sticky;
  inset-block-start: 0;
  z-index: 101;
  background: ${primitive.$white};
`;

export const FilterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  margin-block-end: 0.5rem;
  flex-wrap: wrap;

  & .responsive-carousel-card-container {
    padding: 0;
  }
`;

export const FilterBarWrapper = styled.div`
  width: 100%;
  ${Styles.desktop} {
    width: 75%;
  }
`;

export const PromoCodeButtonBar = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0.5rem;
  border: 2px solid ${primitive.$blackOpacity10};
  width: 100%;
  background: ${primitive.$white};
  padding: 0.75rem 1rem;
  margin-block: 0.65rem;

  .title {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
`;

export const PromoCodeButtonTitle = styled.div`
  font-family: 'Flame', sans-serif;
  font-size: 1rem;
  font-weight: 400;
`;

export const AddPromoIcon = styled.div`
  padding: 0.5rem;
  background-color: ${Styles.color.primary};
  border-radius: 100%;
`;

interface StyledButtonProps {
  isClicked?: boolean;
}

export const StyledButton = styled.button<StyledButtonProps>`
  font-size: 0.88rem;
  padding-block: 0.38rem;
  padding-inline: 1.25rem;
  background-color: ${primitive.$white};
  color: ${p => p.theme.token('text-default')};
  border: 1px solid ${primitive.$blackOpacity30};
  width: max-content;
  border-radius: 4px;
  cursor: pointer;

  ${({ isClicked }) =>
    isClicked &&
    `
      background-color: ${Styles.color.black};
      color: ${primitive.$white};
    `}
`;

export const OfferGrid = styled.div<{
  shouldShowOfferCardPrice: boolean;
  cardWidth: number;
  isMobile: boolean;
}>`
  display: grid;
  width: 100%;
  gap: 15px;
  grid-template-columns: repeat(auto-fill, minmax(${p => p.cardWidth - 40}px, 1fr));
`;
